(function(globalScope) {
  const DENMARK_TIME_ZONE = 'Europe/Copenhagen';

  function getDenmarkDateParts(value) {
    const timestamp = new Date(value);
    if (Number.isNaN(timestamp.getTime())) return null;

    const parts = new Intl.DateTimeFormat('en-CA', {
      day: '2-digit',
      month: '2-digit',
      timeZone: DENMARK_TIME_ZONE,
      year: 'numeric'
    }).formatToParts(timestamp);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));

    return {
      day: Number(values.day),
      month: Number(values.month),
      year: Number(values.year)
    };
  }

  function getDateParts(value) {
    if (typeof value !== 'string') return null;

    const normalizedValue = value.trim();
    const isoMatch = normalizedValue.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)?)?$/
    );
    const displayMatch = normalizedValue.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    const match = isoMatch || displayMatch;
    if (!match) return null;
    if (isoMatch && (normalizedValue.includes('T') || normalizedValue.includes(' '))) {
      return getDenmarkDateParts(normalizedValue);
    }

    const year = Number(isoMatch ? match[1] : match[3]);
    const month = Number(match[2]);
    const day = Number(isoMatch ? match[3] : match[1]);
    if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31) return null;

    const date = new Date(Date.UTC(year, month - 1, day));
    if (
      date.getUTCFullYear() !== year
      || date.getUTCMonth() !== month - 1
      || date.getUTCDate() !== day
    ) {
      return null;
    }

    return { day, month, year };
  }

  function getDateKey(dateParts) {
    return (dateParts.year * 10000) + (dateParts.month * 100) + dateParts.day;
  }

  function formatDateParts(dateParts) {
    return [
      String(dateParts.day).padStart(2, '0'),
      String(dateParts.month).padStart(2, '0'),
      String(dateParts.year)
    ].join('-');
  }

  function getVisibleNextDeliveryDate(value, currentStoreDate) {
    const deliveryDate = getDateParts(value);
    const storeDate = currentStoreDate === undefined
      ? getDenmarkDateParts(new Date())
      : getDateParts(currentStoreDate);
    if (!deliveryDate || !storeDate || getDateKey(deliveryDate) < getDateKey(storeDate)) return '';

    return formatDateParts(deliveryDate);
  }

  const exported = { getVisibleNextDeliveryDate };

  if (typeof module !== 'undefined' && module.exports) module.exports = exported;
  if (globalScope) globalScope.NextDeliveryDate = exported;
}(typeof window !== 'undefined' ? window : null));
